import React from "react";
import { apiGet, getHostApi, getLanguage, isOnPath } from "../../store/apiWrapper";
import { bindActionCreators } from 'redux';
import { Circles } from '../common/loadingComponent';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { Link } from "react-router-dom";
import { marketingListActions, unicornSearchStatus, overviewStates, unicornCountry } from '../../store/marketingListStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { writeErr } from '../common/logger';
import classnames from 'classnames';
import ModalInner from "../layoutItems/modalInner";

const Ok = "Ok";
const InvalidRequest = "InvalidRequest";
const AccountNotExists = "AccountNotExists";
const InsufficientCredit = "InsufficientCredit";
const SearchLimitExceeded = "SearchLimitExceeded";
const ConfigNotValid = "ConfigNotValid";
const NoData = "NoData";
const Error = "Error";

class RequestsPopup extends React.Component {
    mounted = false;
    state = {
        data: {},
        loading: false,
        status: null,
        errMsg: null
    };

    render() {
        return (
            <ModalInner title={this.props.translate("MarketingList.Results.ExportPopup.Header")} close={this.props.close}>
                {this.state.loading
                    ? <div style={{ width: "100%", textAlign: "center" }}>
                        {this.renderIcon()}
                    </div>
                    : <>
                        {this.state.status === Ok && this.renderSuccess()}
                        {this.state.status === InsufficientCredit && this.renderNotEnoughCredit()}
                        {this.state.status === SearchLimitExceeded && this.renderNotEnoughCreditMarketing()}
                        {this.state.status === NoData && this.renderNoData()}
                        {this.state.status === ConfigNotValid && this.renderError('MarketingList.Popup.InvalidConfig')}
                        {this.state.status === Error && this.renderError(this.state.errMsg)}
                        {this.state.status === AccountNotExists && this.renderError('UnhappyUser.NoValidAccount')}
                    </>}
            </ModalInner>
        )
    }

    componentDidMount = () => {
        this.mounted = true;
        this.setState({ loading: true });
        this.loadEstimate();
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    renderIcon = () => <Circles />

    renderSuccess = () => {
        return (
            <>
                {this.state.data.max > 0 && <div className="columns">
                    <div className="column has-text-centered">
                        <Translate id="MarketingList.Results.ExportPopup.Accounts"
                            options={{ renderInnerHtml: true }}
                            data={{ count: this.state.data.max }} />
                    </div>
                </div>}
                {this.state.data.accounts && <div className="columns">
                    <div className="column has-text-centered has-text-weight-bold">
                        {this.state.data.accounts.map((a, i) => <React.Fragment key={i}>{i > 0 ? "," : ""}  <span>{a.accountType}</span></React.Fragment>)}
                    </div>
                </div>}
                {this.state.data.max > 0 && <div className="columns">
                    <div className="column has-text-centered">
                        <Translate id="MarketingList.Results.ExportPopup.Confirm" />
                    </div>
                </div>}
                {this.state.data.max === 0 && <div className="columns">
                    <div className="column has-text-centered">
                        <Translate id="MarketingList.Results.ExportPopup.ConfirmFree" />
                    </div>
                </div>}
                <div className="modal-inner-buttons">
                    <button className={classnames('bb-button is-primary gradient-1 ml-btn', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={this.onExport} disabled={this.state.loading}>
                        <Translate id="Common.Yes.Upper" />
                    </button>
                </div>
            </>
        )
    }

    renderNotEnoughCredit = () => {
        return (
            <>
                <div className="columns">
                    <div className="column has-text-centered">
                        <Translate id="MarketingList.Popup.NotEnoughCredit.Text" />
                        <a href={getLanguage() === "sk-SK" ? "https://www.crif.sk/" : "https://www.crif.cz/"}>
                            <Translate id={getLanguage() === "sk-SK" ? "Common.Crif.Sk" : "Common.Crif.Cz"} />
                        </a>
                    </div>
                </div>
                <div className="columns">
                    <div className="column has-text-centered">
                        <Translate id="MarketingList.Popup.NotEnoughCredit.Text2"
                            options={{ renderInnerHtml: true }}
                            data={{ href: `<a href='user/info'>${this.props.translate("Common.Here")}</a>` }} />
                    </div>
                </div>
                <div className="modal-inner-buttons">
                    <button className={classnames('bb-button is-primary gradient-1 ml-btn', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={this.props.close}>
                        <Translate id="Common.Close" />
                    </button>
                </div>
            </>
        )
    }

    renderNotEnoughCreditMarketing = () => {
        return (
            <>
                <div className="columns">
                    <div className="column has-text-centered">
                        <Translate id="MarketingList.NotEnough.MarketingCz" data={{ count: this.state.data.totalSubjects, limit: this.state.data.maxSubjects }} />
                    </div>
                </div>
                <div className="modal-inner-buttons">
                    <Link className={classnames('bb-button is-primary gradient-1 ml-btn', { 'is-square': localStorage.locales_button_style === 'square' })}
                        to={`/unicorn/${unicornCountry()}/parameters?requestId=${this.props.data.requestId}&configId=${this.props.data.export}`}
                        onClick={() => this.props.close()} disabled={this.state.loading} >
                        <Translate id="MarketingList.Results.Button.EditParams" />
                    </Link>
                </div>
            </>
        )
    }

    renderNoData = () => {
        return (
            <>
                <div className="columns">
                    <div className="column has-text-centered" style={{ margin: '1em 0' }}>
                        <Translate id="Report.Common.SectionNoData" />
                    </div>
                </div>
                <div className="modal-inner-buttons">
                    <button className={classnames('bb-button is-primary gradient-1-gray ml-btn', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={this.props.close}>
                        <Translate id="Common.Close" />
                    </button>
                    <button className={classnames('bb-button is-primary gradient-1 ml-btn', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={this.onCancel} disabled={this.state.loading}>
                        <Translate id="Common.Button.Cancel" />
                    </button>
                </div>
            </>
        )
    }
    renderError = (id) => {
        return (
            <>
                <div className="columns">
                    <div className="column has-text-centered" style={{ margin: '1em 0' }}>
                        <Translate id={id} options={{ renderInnerHtml: true }} />
                    </div>
                </div>
                <div className="modal-inner-buttons">
                    <button className={classnames('bb-button is-primary gradient-1-gray ml-btn', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={this.props.close}>
                        <Translate id="Common.Close" />
                    </button>
                </div>
            </>
        )
    }

    onExport = () => {
        this.props.updateRequestStatus(this.props.data.requestId, unicornSearchStatus.exportPending, this.props.data.order, this.props.data.orderBy, this.props.data.exportFrom, this.props.data.exportTo,
            () => {
                this.props.getRequests(this.props.page - 1, this.props.pageSize);
                if (isOnPath({ prefix: "/unicorn/overview" }))
                    window.close();
            });
        this.props.toggleMlOverview(overviewStates.closed, null, null, null);
        this.props.close();
    }

    onCancel = () => {
        this.props.updateRequestStatus(this.props.data.requestId, unicornSearchStatus.canceled, null, null, null, null, isOnPath({ prefix: "/unicorn/overview" }) ? () => window.close() : null);
        this.props.toggleMlOverview(overviewStates.closed, null, null, null);
        this.props.close();
    }

    loadEstimate = () => {
        var url = `${getHostApi()}/api/marketing-list/request/${this.props.data.requestId}/estimate`;
        if (this.props.data.exportFrom && this.props.data.exportTo)
            url += `/${this.props.data.exportFrom}/${this.props.data.exportTo}`;
        apiGet(url,
            null,
            (d) => this.estimateSuccess(d),
            (e) => this.estimateFail(e),
            () => { this.mounted && this.setState({ loading: false }) })
    }

    estimateSuccess = (data) => {
        this.setState({
            status: isNullOrUndefined(data.data) ? data.error.message : data.data.error,
            data: isNullOrUndefined(data.data) ? {} : data.data
        });
    }

    estimateFail = (err) => {
        writeErr(`/api/marketing-list/request/${this.props.data.requestId}/estimate Error`, err);
        this.setState({
            status: Error,
            errMsg: err ? err.data.error.message : 'UnhappyUser.InternalServerError'
        });
    }
}

export default withRouter(withLocalize(connect(
    state => state.marketingList,
    dispatch => bindActionCreators(marketingListActions, dispatch)
)(RequestsPopup)));
